import { FC } from "react";
import { SizeMeasurement } from "@/utils/inspection.utils.ts";
import AddDefectIcon from "@/assets/icons/add_defect_icon.png";
import styles
    from "@/features/inspection-details/components/record-measurement/components/styles/MeasurementRecordRow.module.scss";
import { DecimalInput } from "@/components/DecimalInput/DecimalInput";

interface MeasurementRecordRowProps {
    measurement: SizeMeasurement;
    measurementIndex: number;
    passIndex:string,
    sizeKey: string;
    readOnly?: boolean;
    showDefectColumn?: boolean;
    handleInputChange: (
        sizeKey: string,
        value: number | null,
        sizeChartId: string,
        measurementId: string | null
    ) => void;
    onAdd: () => void;
}

export const MeasurementRecordRow: FC<MeasurementRecordRowProps> = ({
    measurement,
    measurementIndex,
    sizeKey,
    passIndex,
    readOnly = false,
    showDefectColumn = true,
    handleInputChange,
    onAdd,
}) => {
    const variance = measurement.measurement
        ? parseFloat((Number(measurement.measurement) - measurement.targetMeasurement).toFixed(2))
        : 0;
    const isOutOfTolerance = variance > measurement.tolerancePlus || variance < measurement.toleranceMinus

    return (<>

        <div className={`${styles.rowHeader} ${!showDefectColumn ? styles.rowNoDefect : ''}`}>
            <div className={styles.rowHeaderCol1}>{measurement.dimensionCode}</div>
            <div className={styles.rowHeaderCol2}>{measurement.dimensionDescription}</div>
        </div>


        <div className={`${styles.tableRow} ${!showDefectColumn ? styles.rowNoDefect : ''}`}>

            <div className={styles.tableCell}>{measurement.targetMeasurement}</div>
            <div className={styles.tableCell}>{`${measurement.toleranceMinus}`}</div>
            <div className={styles.tableCell}>{`${measurement.tolerancePlus}`}</div>
            <div
                style={{ color: isOutOfTolerance ? 'red' : 'black' }}
                className={styles.tableCell}
            >
                {variance || ''}
            </div>
            <div className={styles.tableCell}>
                {readOnly ? (
                    <span>{measurement.measurement ?? ''}</span>
                ) : (
                    <DecimalInput
                        name={`measurement-${passIndex}-${sizeKey}-${measurementIndex}`}
                        value={measurement.measurement ? parseFloat(measurement.measurement.toString()) : null}
                        min={0}
                        onChange={e =>
                            handleInputChange(
                                sizeKey,
                                e.target.value,
                                measurement.sizeChartId,
                                measurement.measurementId
                            )
                        }
                    />
                )}

            </div>
            {showDefectColumn && (
                <div className={`${styles.tableCell} ${styles.defectCell}`}>
                    {isOutOfTolerance && (
                        <img
                            onClick={() => onAdd()}
                            className={styles.addDefectIcon}
                            src={AddDefectIcon}
                            alt="Add Defect"
                        />
                    )}
                </div>
            )}
        </div>
    </>
    );
};
